import React, { useContext, useState } from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';

import Column from '@amzn/meridian/column';
import { TenantIdContext } from '../../../src/components/app/App';
import Text from '@amzn/meridian/text';
import escapeRegExp from 'lodash/escapeRegExp';

const TenantSelector = ({ onChange, availableTenantIds }) => {
  const tenantId = useContext(TenantIdContext);
  const [searchQuery, setSearchQuery] = useState();

  const searchRegExp = new RegExp(escapeRegExp(searchQuery), 'i');
  const matchedOptions = availableTenantIds.filter(option => !searchQuery || searchRegExp.test(option));

  return (
    <Select
      label="Tenant Id"
      value={tenantId}
      onChange={newId => onChange(newId)}
      searchQuery={searchQuery}
      onSearch={setSearchQuery}
    >
      {matchedOptions.map(tenantId => (
        <SelectOption label={tenantId} value={tenantId} key={tenantId} />
      ))}
      {!matchedOptions.length ? (
        <Column alignmentVertical="center" spacing="300" spacingInset="600">
          <Text alignment="center">No results</Text>
        </Column>
      ) : null}
    </Select>
  );
};

export default TenantSelector;
